import { React, Suspense} from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import './i18n';
import store from './Store/configureStore';
import App from "./Components/App.js";
import './Styles/mainstyle.scss';

//import './Styles/mainstyles.css';
//import "./index.css";

//const store = configureStore(initState);
//console.log(store.getState());



ReactDOM.render(
	<Provider store={store}>
		<Router>
			<Suspense fallback="loading"><App/></Suspense>
		</Router>
	</Provider>,
	
	document.querySelector("#app")
);